module.exports = __webpack_public_path__ + "static/media/Gressel.833a6fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/Gressel.png
// module id = 465
// module chunks = 0